import React from "react";
import { PrefillSlotsCompProps } from "./types";

// Prefill Slots Component
export function PrefillSlotsComp({ handleConfirm, dates, parsedTimes }: PrefillSlotsCompProps): React.ReactElement {
	return (
		<div className="w-full flex flex-col p-6 justify-around items-center">
			<h2 className="text-lg font-semibold text-gray-800 mb-4">Existing Slots found</h2>

			<p className="text-center text-gray-700 mb-6 text-sm leading-relaxed">
				You have already provided the following slots while requesting the visit on a nearby property that is within a
				radius of 10 km. Would you like us to automatically fill in these details for you?
			</p>

			<div className="w-full mb-6 bg-gray-50 rounded-lg p-4 border border-gray-200 overflow-x-auto">
				<table className="w-full border-collapse">
					<tbody>
						{dates.map(el => (
							<tr key={el} className="border-b border-gray-200 last:border-b-0">
								<td className="py-3 px-3 font-medium text-gray-800 text-sm whitespace-nowrap">{el}</td>
								<td className="py-3 px-3 text-gray-600 text-sm">{parsedTimes[el].join(", ")}</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>

			<div className="w-full gap-2 flex flex-row justify-around items-center">
				<button
					className="flex-1 cursor-pointer px-4 py-2 bg-primary text-white rounded text-sm font-medium hover:bg-primary/90 transition-colors"
					onClick={() => handleConfirm(true)}
				>
					Yes, Autofill
				</button>
				<button
					className="flex-1 cursor-pointer px-4 py-2 text-primary-700 rounded text-sm font-medium hover:bg-primary/10 transition-colors"
					onClick={() => {
						handleConfirm(false);
					}}
				>
					Skip
				</button>
			</div>
		</div>
	);
}
